import { render, staticRenderFns } from "./Sdgs.vue?vue&type=template&id=c5a81154&scoped=true"
import script from "./Sdgs.vue?vue&type=script&lang=ts"
export * from "./Sdgs.vue?vue&type=script&lang=ts"
import style0 from "./Sdgs.vue?vue&type=style&index=0&id=c5a81154&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5a81154",
  null
  
)

export default component.exports